import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import CountUp from "react-countup";
import { getReservations } from "store/reservation/thunk";
// import { Switch } from "antd";
import countryApi from "api/countryApi";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import ModalPreview from "components/Common/ModalPreview";
import {
  ARRANGE_STATUS_OPTION,
  BOOKING_STATUS_OPTION,
  BOOKING_TYPE_OPTION,
  COLOR_STATUS_POST,
  LIST_OPTION_PLATFORM,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import UserForm from "./UserForm";
import BarListDetail from "pages/BarList/BarListDetail";
import DropdownAsyncBars from "components/Common/DropdownAsyncBars";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import DropdownOption from "components/Common/DropdownOption";
import BarTableApi from "api/barTableApi";
import DropdownAsyncBarTable from "components/Common/DropdownAsyncBarTable";

interface Option {
  label: string;
  value: string;
}

export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const TYPE_SELECT_DEFAULT: string = "created_at";

const ReservationList = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, `DESC`),
    // date_version: withDefault(StringParam, ''),
    keyword: withDefault(StringParam, ""),
    bar_id: withDefault(StringParam, ""),
    table_id: withDefault(StringParam, ""),
    booking_user_id: withDefault(StringParam, ""),
    booking_type: withDefault(StringParam, ""),
    arrange_type: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [allBarTables, setAllBarTables] = useState<any>(null);

  const BOOKING_TYPE_OPTION_LANG =
    BOOKING_TYPE_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const BOOKING_STATUS_OPTION_LANG =
    BOOKING_STATUS_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const ARRANGE_STATUS_OPTION_LANG =
    ARRANGE_STATUS_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [keywordSearch, setKeywordSearch] = useState<string>(
    query?.keyword || ""
  );

  const [barSearch, setBarSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [barTableSearch, setBarTableSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [booking_user_search, set_booking_user_search] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [booking_type, set_booking_type] = useState<any>(
    BOOKING_TYPE_OPTION?.find((item) => item?.value === parseInt(query?.status))
      ?.value ?? ""
  );

  const [reservation_status, set_reservation_status] = useState<any>(
    BOOKING_STATUS_OPTION?.find(
      (item) => item?.value === parseInt(query?.status)
    )?.value ?? ""
  );

  const [arrange_status, set_arrange_status] = useState<any>(
    ARRANGE_STATUS_OPTION?.find(
      (item) => item?.value === parseInt(query?.status)
    )?.value ?? ""
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [start_date, end_date] = dateSearch;

  const selectLayoutState = (state: any) => state.Reservation;

  const ReservationProperties = createSelector(selectLayoutState, (state) => ({
    reservations: state.reservations,
    isReservationLoading: state.isReservationLoading,
    isReservationSuccess: state.isReservationSuccess,

    error: state.error,
  }));

  // useEffect(() => {
  //   if (!barSearch?.data?.id) return;
  //   const asyncGetData = async () => {
  //     const res = await BarTableApi.barTable({
  //       page: 1,
  //       limit: 100,
  //       bar_id: barSearch?.data?.id,
  //     });
  //     console.log(res);
  //     if (res?.code == 200) setAllBarTables(res?.data?.list);
  //   };
  //   asyncGetData();
  // }, [barSearch?.data?.id]);

  // Inside your component
  const { reservations, isReservationLoading } = useSelector(
    ReservationProperties
  );

  function loadTableData() {
    dispatch(getReservations(query));
  }

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      keyword: keywordSearch || "",
      bar_id: barSearch?.data?.id || "",
      table_id: barTableSearch?.data?.id || "",
      booking_user_id: booking_user_search?.data?.id || "",
      booking_type: booking_type?.value || "",
      arrange_type: arrange_status?.value || "",
      status: reservation_status?.value || "",
      start_date: start_date
        ? formatDateStringToUTC(
            moment(new Date(start_date))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      end_date: end_date
        ? formatDateStringToUTC(
            moment(new Date(end_date)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        start_date: "",
        end_date: "",
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setKeywordSearch((_prev) => "");
    setBarSearch((_prev: any) => null);
    setBarTableSearch((_prev: any) => null);
    set_booking_user_search((_prev: any) => null);
    set_booking_type((_prev: any) => null);
    set_arrange_status((_prev: any) => null);
    set_reservation_status((_prev: any) => null);

    set_reservation_status("");
    setDateSearch([null, null]);
  };

  // Begin::Update User
  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    dispatch(getReservations(query));
  };
  //End::Update User

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div>
              {reservations?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },

      {
        Header: t("Reservation Code"),
        accessor: "reservation_code",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value}</div>
            </>
          );
        },
      },

      {
        Header: t("Store Name"),
        accessor: "bar_title",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: "150",
        Cell: (cell: any) => {
          return <>{cell?.value}</>;
        },
      },

      {
        Header: t("Reservation Status"),
        accessor: "status",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const bookingStatus = BOOKING_STATUS_OPTION_LANG.find(
            (item) => item?.value == cell?.value
          );
          return (
            <>
              <div className="cursor-pointer">{bookingStatus?.label}</div>
            </>
          );
        },
      },

      {
        Header: t("Booking Type"),
        accessor: "booking_type",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const bookingType = BOOKING_TYPE_OPTION_LANG.find(
            (item) => item?.value == cell?.value
          );

          return (
            <>
              <div className="cursor-pointer">{bookingType?.label}</div>
            </>
          );
        },
      },

      {
        Header: t("User On App"),
        accessor: "ub_nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value}</div>
            </>
          );
        },
      },

      {
        Header: t("Contact Info"),
        accessor: "phone_contact",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value}</div>
            </>
          );
        },
      },

      {
        Header: t("Reservation Time"),
        accessor: "attending_date", // add time
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;

          const fullDate = `${item?.attending_date} ${item?.attending_time}`;
          const date = formatDateStringToKorea(fullDate);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },

      {
        Header: t("Number of People"),
        accessor: "slot",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer text-end">{cell?.value}</div>
            </>
          );
        },
      },

      {
        Header: t("Arrange Table Status"),
        accessor: "reservation_table_id",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const arrangeStatus = ARRANGE_STATUS_OPTION_LANG.find(
            (item) => item?.value == cell?.value
          );
          return (
            <>
              <div className="cursor-pointer">{arrangeStatus?.label}</div>
            </>
          );
        },
      },

      {
        Header: t("Table Name"),
        accessor: "bt_name",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value}</div>
            </>
          );
        },
      },

      {
        Header: t("Specific Request"),
        accessor: "note",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value}</div>
            </>
          );
        },
      },

      {
        Header: t("Payment Method"),
        accessor: "payment_method",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value}</div>
            </>
          );
        },
      },

      {
        Header: t("Staff-Managed Booking"),
        accessor: "ba_name",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value}</div>
            </>
          );
        },
      },
      {
        Header: t("Staff Assigning Table"),
        accessor: "bat_name",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value}</div>
            </>
          );
        },
      },

      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end pe-3" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return <></>;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`update-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(true);
                      setItemToEdit(item);
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`delete-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-danger edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToDelete(item);
                    }}
                  >
                    <i className="ri-delete-bin-3-fill align-bottom"></i>
                  </Link>
                </li>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, reservations]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };
  // Begin::Delete

  // End::Delete

  useEffect(() => {
    document.title = `${t("Reservation Status")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Reservation Status")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={reservations?.summary?.Total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Serving")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={reservations?.summary?.InUse || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Waiting")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      reservations?.summary?.InWaitingApprove ||
                                      0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Cancel")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={reservations?.summary?.Cancel || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3"
                      >
                        <LabelWrapper isShow={!!keywordSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Name")}/${t("Phone Number")}/${t(
                              "Email"
                            )}/${t("Note")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <div>
                          <LabelWrapper label={t("Store List")} isShow={true}>
                            <DropdownAsyncBars
                              name="bar"
                              onChangeSelect={(event: any) => {
                                setBarSearch(event);
                                setBarTableSearch(null);
                                set_booking_user_search(null);
                              }}
                              isMulti={false}
                              placeholder={`${t("Select Store")}...`}
                              isShowIconCheck={false}
                              isAllOption={true}
                              listCheckedUsers={barSearch}
                            />
                          </LabelWrapper>
                        </div>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <div>
                          <LabelWrapper label={t("Table")} isShow={true}>
                            <DropdownOption
                              name="table"
                              // onChangeSelect={(event: any) =>
                              //   setBarSearch(event)
                              // }
                              placeholder={`${t("Select Table")}...`}
                              isHasOptionAll={true}
                              dataList={allBarTables?.map((i: any) => {
                                const returnObject = {
                                  value: i?.id,
                                  label: i?.name,
                                };
                                return returnObject;
                              })}
                              optionAll={{ label: t("All Filter"), value: "" }}
                              className="dropdown-status-rounded"
                            />
                          </LabelWrapper>
                        </div>
                      </Col> */}

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <div>
                          <LabelWrapper label={t("Table")} isShow={true}>
                            <DropdownAsyncBarTable
                              name="barTable"
                              onChangeSelect={(event: any) =>
                                setBarTableSearch(event)
                              }
                              isMulti={false}
                              placeholder={`${t("Select Bar Table")}...`}
                              isShowIconCheck={false}
                              isAllOption={true}
                              listCheckedUsers={barTableSearch}
                              bar_id={barSearch?.data?.id}
                              key={barSearch?.data?.id}
                            />
                          </LabelWrapper>
                        </div>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Booking User")} isShow={true}>
                          <DropdownAsyncUsers
                            name="booking_user"
                            onChangeSelect={(event: any) =>
                              set_booking_user_search(event)
                            }
                            isMulti={false}
                            placeholder={`${t("Select Bartender")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={booking_user_search}
                            keywordSearch={barSearch?.value}
                            key={barSearch?.data?.id}
                            defaultParams={{ is_active: 1 }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Booking Type")} isShow={true}>
                          <DropdownOption
                            name="Booking Type"
                            dataList={BOOKING_TYPE_OPTION_LANG || []}
                            placeholder={`${t("Booking Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={booking_type || null}
                            onChangeSelect={(e: any) => set_booking_type(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Arrange Table Status")}
                          isShow={true}
                        >
                          <DropdownOption
                            name="status arrange"
                            dataList={ARRANGE_STATUS_OPTION_LANG || []}
                            placeholder={`${t("Arrange Table Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={arrange_status}
                            onChangeSelect={(e: any) => set_arrange_status(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Reservation Status")}
                          isShow={true}
                        >
                          <DropdownOption
                            name="status arrange"
                            dataList={BOOKING_STATUS_OPTION_LANG || []}
                            placeholder={`${t("Reservation Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={reservation_status}
                            onChangeSelect={(e: any) =>
                              set_reservation_status(e)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={12}
                        lg={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={
                        reservations?.list?.length ? reservations?.list : []
                      }
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={reservations?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(reservations?.pagination?.total) /
                          Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isReservationLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          isOpen={!!itemToEdit?._id || isOpen}
          centered={true}
          size="xl"
          scrollable={true}
        >
          <ModalHeader toggle={onCloseClick}>
            <>
              {!!itemToEdit?._id
                ? t("Button Update User")
                : t("Button Create User")}
            </>{" "}
            <>
              {itemToEdit?._id && (" - " + (itemToEdit?.nickname || "") || "")}
            </>
          </ModalHeader>
          <ModalBody>
            <div style={{ minHeight: "calc(100dvh - 200px)" }}>
              <UserForm
                isModal={true}
                id={String(itemToEdit?._id || "")}
                isCopy={!!itemToEdit?.isCopy}
                triggerRefresh={triggerRefresh}
                LIST_OPTION_ROLE={[]}
              />
            </div>
          </ModalBody>
        </Modal>

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete User")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            // onConfirm={() => handleActionDelete(itemToDelete?._id)}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default ReservationList;
